module.exports = "<label class=\"switcher-container\">\n  <input type=\"checkbox\" ng-model=\"switcherValue\">\n  <div class=\"switcher\" ng-class=\"::switcherStyle\">\n    <div class=\"handle-container\">\n      <span class=\"handle handle-on\">ON</span>\n      <span class=\"handle\"></span>\n      <span class=\"handle handle-off\">OFF</span>\n    </div>\n  </div>\n</label>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blur_admin/src/app/theme/inputs/baSwitcher/baSwitcher.html
// module id = 830
// module chunks = 2